"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var Option_1 = __importDefault(require("../OptionsMenu/Option"));
var styles_less_1 = __importDefault(require("./styles.less"));
var CastDevicesMenu = (0, react_1.memo)((0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, devices = _a.devices, loading = _a.loading, onDeviceSelected = _a.onDeviceSelected;
    var t = (0, react_i18next_1.useTranslation)().t;
    var onMouseDown = react_1.default.useCallback(function (event) {
        // @ts-expect-error: Property 'castDevicesMenuClosePrevented' does not exist on type 'MouseEvent'.
        event.nativeEvent.castDevicesMenuClosePrevented = true;
    }, []);
    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)(className, styles_less_1.default['cast-devices-menu-container']), onMouseDown: onMouseDown }, devices.length > 0 ?
        devices.map(function (_a) {
            var id = _a.id, name = _a.name;
            return (react_1.default.createElement(Option_1.default, { key: id, icon: 'cast', label: t('PLAYER_PLAY_IN', { device: name }), deviceId: id, onClick: onDeviceSelected }));
        })
        :
            react_1.default.createElement("div", { className: styles_less_1.default['message'] }, loading ?
                t('STREAM_LOADING')
                :
                    t('PLAYER_NO_CAST_DEVICES_FOUND'))));
}));
exports.default = CastDevicesMenu;
